import { render, staticRenderFns } from "./G_020_JuchuEntry_ChildHeaderInput.vue?vue&type=template&id=2a273526&scoped=true&"
import script from "./G_020_JuchuEntry_ChildHeaderInput.vue?vue&type=script&lang=ts&"
export * from "./G_020_JuchuEntry_ChildHeaderInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a273526",
  null
  
)

export default component.exports